import React from 'react';

function Progress() {
  return (
    <div className="progress">
      <h5 className="current-chapter">CURRENT CHAPTER</h5>
      <h4 className="chapter-description">Chapter 17</h4>
      <button type="button">UPDATE PROGRESS</button>
    </div>
  );
}

export default Progress;
